module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-magnifying-glass-dbd7f4491b76a712f63bc308a8910ac8.svg";